new VenoBox({
    selector: ".venobox",
    numeration: true,
    infinigall: true,
    share: true,
    spinner: "rotating-plane"
});

//# sourceURL=webpack://lp_create_kit/./src/js/venobox.js?